import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import PdfBulletListContent from "../../../../../../lib/html5-software-library/src/ranj/pdf/content/generic/PdfBulletListContent";
import AbstractPdfSection from "../../../../../../lib/html5-software-library/src/ranj/pdf/sections/AbstractPdfSection";
import BackendService from "../../../backend/controller/BackendService";
import ProgressModel from "../../../progress/model/ProgressModel";
import PersonalReportConfig from "../../model/PersonalReportConfig";
import PersonalReportModel from "../../model/PersonalReportModel";

export default class TipsSection extends AbstractPdfSection {
    /**
     * @constructor
     * @param {PersonalReportConfig} pdfConfig 
     * @param {LanguagePack} languagePack
     * @param {PersonalReportModel} personalReportModel
     */
    constructor(pdfConfig, languagePack, personalReportModel) {
        super(pdfConfig.pageWidth);

        this._pdfConfig = pdfConfig;
        this._languagePack = languagePack;
        this._personalReportModel = personalReportModel;
    }

    async loadData() {
        
    }

    initialize() {
        super.initialize();

        const title = this._languagePack.getText('personalReport.tips.title');
        this.addText(title, this._pdfConfig.getValue("elements.general.h3"));

        for (const tip of this._personalReportModel.tips) {
            this.addText(`• ${tip.title}`, this._pdfConfig.getValue("elements.general.h4"));
            this.addText(tip.content, this._pdfConfig.getValue("elements.general.div"));

            this.addPageBreak(false);
        }

        const endingText = this._languagePack.getText('personalReport.tips.ending');
        this.addText(endingText, this._pdfConfig.getValue("elements.general.p"));

        this.addPageBreak(false);
    }
}